import { render, staticRenderFns } from "./modal-basic.vue?vue&type=template&id=4831157e&"
import script from "./modal-basic.vue?vue&type=script&lang=js&"
export * from "./modal-basic.vue?vue&type=script&lang=js&"
import style0 from "./modal-basic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports